export var UFColor = /*#__PURE__*/function (UFColor) {
  UFColor[UFColor["RED"] = 1] = "RED";
  UFColor[UFColor["YELLOW"] = 2] = "YELLOW";
  UFColor[UFColor["GREEN"] = 3] = "GREEN";
  UFColor[UFColor["PURPLE"] = 4] = "PURPLE";
  return UFColor;
}(UFColor || {});
export var OvulationPrediction = /*#__PURE__*/function (OvulationPrediction) {
  OvulationPrediction["OVULATION"] = "OVULATION";
  OvulationPrediction["WINDOW1"] = "WINDOW1";
  OvulationPrediction["WINDOW2"] = "WINDOW2";
  return OvulationPrediction;
}(OvulationPrediction || {});
export var LHStatus = /*#__PURE__*/function (LHStatus) {
  LHStatus[LHStatus["LH_PREDICTION"] = 1] = "LH_PREDICTION";
  LHStatus[LHStatus["LH_NEG_PRE_OVU_CONFIRMED"] = 2] = "LH_NEG_PRE_OVU_CONFIRMED";
  LHStatus[LHStatus["LH_POS_PRE_OVU_CONFIRMED"] = 3] = "LH_POS_PRE_OVU_CONFIRMED";
  LHStatus[LHStatus["LH_NEG_OVU_DAY"] = 4] = "LH_NEG_OVU_DAY";
  LHStatus[LHStatus["LH_POS_OVU_CONFIRMED"] = 5] = "LH_POS_OVU_CONFIRMED";
  LHStatus[LHStatus["LH_POS_OVU_NOT_CONFIRMED"] = 6] = "LH_POS_OVU_NOT_CONFIRMED";
  return LHStatus;
}(LHStatus || {});
export var OvulationStatus = /*#__PURE__*/function (OvulationStatus) {
  OvulationStatus[OvulationStatus["OVU_CONFIRMED"] = 1] = "OVU_CONFIRMED";
  OvulationStatus[OvulationStatus["OVU_NOT_CONFIRMED"] = 2] = "OVU_NOT_CONFIRMED";
  OvulationStatus[OvulationStatus["OVU_WAITING"] = 3] = "OVU_WAITING";
  OvulationStatus[OvulationStatus["OVU_PREDICTION"] = 4] = "OVU_PREDICTION";
  OvulationStatus[OvulationStatus["OVU_DAY"] = 5] = "OVU_DAY";
  OvulationStatus[OvulationStatus["ANOVULATORY"] = 6] = "ANOVULATORY";
  return OvulationStatus;
}(OvulationStatus || {});
export var PregnancyTestStatus = /*#__PURE__*/function (PregnancyTestStatus) {
  PregnancyTestStatus[PregnancyTestStatus["PREG_PREDICTION"] = 1] = "PREG_PREDICTION";
  PregnancyTestStatus[PregnancyTestStatus["PREG_NEGATIVE"] = 2] = "PREG_NEGATIVE";
  PregnancyTestStatus[PregnancyTestStatus["PREG_POSITIVE"] = 3] = "PREG_POSITIVE";
  return PregnancyTestStatus;
}(PregnancyTestStatus || {});
export var PregnancyStatus = /*#__PURE__*/function (PregnancyStatus) {
  PregnancyStatus[PregnancyStatus["PREGNANT"] = 1] = "PREGNANT";
  PregnancyStatus[PregnancyStatus["NOT_PREGNANT"] = 2] = "NOT_PREGNANT";
  PregnancyStatus[PregnancyStatus["UNKNOWN"] = 3] = "UNKNOWN";
  return PregnancyStatus;
}(PregnancyStatus || {});
export var MedicalFlag = /*#__PURE__*/function (MedicalFlag) {
  MedicalFlag[MedicalFlag["CYCLE_LENGTH"] = 1] = "CYCLE_LENGTH";
  MedicalFlag[MedicalFlag["MENS_LENGTH"] = 2] = "MENS_LENGTH";
  MedicalFlag[MedicalFlag["ANOVULATION"] = 3] = "ANOVULATION";
  MedicalFlag[MedicalFlag["LUTEAL_LENGTH"] = 4] = "LUTEAL_LENGTH";
  MedicalFlag[MedicalFlag["CYCLE_LENGTH_VARIATION"] = 5] = "CYCLE_LENGTH_VARIATION";
  MedicalFlag[MedicalFlag["LONG_CYCLE"] = 6] = "LONG_CYCLE";
  MedicalFlag[MedicalFlag["SHORT_CYCLE"] = 7] = "SHORT_CYCLE";
  MedicalFlag[MedicalFlag["SHORT_FOLLICULAR_PHASE"] = 8] = "SHORT_FOLLICULAR_PHASE";
  MedicalFlag[MedicalFlag["LONG_FOLLICULAR_PHASE"] = 9] = "LONG_FOLLICULAR_PHASE";
  return MedicalFlag;
}(MedicalFlag || {});
export var MedicalFlagLabel = /*#__PURE__*/function (MedicalFlagLabel) {
  MedicalFlagLabel[MedicalFlagLabel["TYPICAL"] = 1] = "TYPICAL";
  MedicalFlagLabel[MedicalFlagLabel["IRREGULAR"] = 2] = "IRREGULAR";
  return MedicalFlagLabel;
}(MedicalFlagLabel || {});